import React from 'react'
import { EColor } from '@frontend/pole-ui/lib/common/constants'
import { EIconSize } from '@frontend/pole-ui/lib/components/Icon'
import { InfoFillIcon } from '@frontend/pole-ui/lib/components/Icon/svg/InfoFillIcon'
import classNames from 'classnames'
import TextWithIcon from '../TextWithIcon/TextWithIcon'
import type { IInfoTextProps } from './interfaces'
import './styles.scss'

const InfoText: React.FC<IInfoTextProps> = props => {
  const {
    color,
    text,
    infoTextId,
    iconProps,
    className,
    textModifier,
    textClassName = 'color_pale-black',
    textValues,
    isDeviceMobile,
  } = props

  return (
    <TextWithIcon
      className={classNames('info-text', className)}
      iconProps={{
        component: <InfoFillIcon />,
        className: 'info-text__icon',
        style: { color: color || EColor.BLACK },
        size: isDeviceMobile ? EIconSize.XS : EIconSize.M,
        ...iconProps,
      }}
      text={text}
      textModifier={textModifier}
      textId={infoTextId}
      textClassName={classNames('info-text__text', textClassName)}
      textValues={textValues}
    />
  )
}

export default InfoText
